import { Users } from "lucide-react";
import PropTypes from "prop-types";
import classnames from "classnames";
import { PUBLISHER_CONTRACT_STATUS as STATUS, PUBLISHER_CONTRACT_STATUS_LABEL } from "@panel/shared/contract/misc/constants";

const DOT_CLASS = {
    [STATUS.AWAITING_BRAND]    : "bg-info",
    [STATUS.AWAITING_PUBLISHER]: "bg-warning",
    [STATUS.SIGNED]            : "bg-success",
    [STATUS.NOT_SENT]          : "bg-muted/60"
};

const CountTile = ({ status, count }) => (
    <div className="flex items-center justify-between rounded-lg border border-gray-200 bg-light/40 px-4 py-3">
        <span className="flex items-center gap-2.5 text-sm text-gray-900">
            <span className={classnames("h-2 w-2 shrink-0 rounded-full", DOT_CLASS[status])} />
            {PUBLISHER_CONTRACT_STATUS_LABEL[status]}
        </span>
        <span className="text-sm font-semibold text-gray-900">{count}</span>
    </div>
);

CountTile.propTypes = {
    status: PropTypes.oneOf(Object.keys(DOT_CLASS)).isRequired,
    count : PropTypes.number.isRequired
};

// Where every publisher of the brand stands. `counts` covers all of them, not
// just the page the table is on. Queued rows are folded into the state they
// are moving into.
const PublisherStatusCard = ({ counts, brandName }) => (
    <section className="rounded-xl border border-gray-200 bg-white p-5 shadow-sm">
        <div className="flex flex-wrap items-end justify-between gap-2">
            <h2 className="flex items-center gap-2 text-base font-semibold text-gray-900">
                <Users className="h-4 w-4 text-muted" />
                Publisher contracts
            </h2>
            <p className="text-xs text-muted">
                <span className="text-lg font-semibold text-gray-900">{counts.total}</span>
                {` publishers associated${brandName ? ` with ${brandName}` : ""}`}
            </p>
        </div>

        <div className="mt-4 grid gap-2 sm:grid-cols-2 lg:grid-cols-4">
            <CountTile status={STATUS.AWAITING_BRAND} count={counts.awaitingBrand + counts.queued} />
            <CountTile status={STATUS.AWAITING_PUBLISHER} count={counts.awaitingPublisher + counts.brandSignQueued} />
            <CountTile status={STATUS.SIGNED} count={counts.signed} />
            <CountTile status={STATUS.NOT_SENT} count={counts.notSent} />
        </div>
    </section>
);

PublisherStatusCard.propTypes = {
    counts: PropTypes.shape({
        total            : PropTypes.number,
        notSent          : PropTypes.number,
        queued           : PropTypes.number,
        awaitingBrand    : PropTypes.number,
        brandSignQueued  : PropTypes.number,
        awaitingPublisher: PropTypes.number,
        signed           : PropTypes.number
    }).isRequired,
    brandName: PropTypes.string
};

export default PublisherStatusCard;
